export default __webpack_public_path__ + "static/media/Nightcrawler-Fx-Pack-01.8d4dc179.jpg";